<template>
  <md-dialog :md-active.sync="showDialog" :md-fullscreen="false">
    <md-dialog-content>
      <p>本契約の手続きは、平日8:30～22:55・土日祝日8:30～17:55の受付となります。</p>
      <p>
        ※受付時間内にこの画面が表示された場合は、メンテナンス中となります。<br>
        誠に申し訳ございませんが、時間を空けて再度お試しいただきますようお願い申し上げます。<br>
        <router-link :to="{name: 'TrialEmail'}"><a>無料トライアル</a></router-link>
        はいつでも登録が可能です。
      </p>
      <p>ご不明な点は<a href="https://www.jon.co.jp/contact/" rel="noopener" tag="md-button" target="_blank">https://www.jon.co.jp/contact/</a>より、お問い合わせください。
      </p>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="showDialog = false">閉じる</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name : 'AnnounceAfterServiceHours',
  props: {
    showDialog: {
      type   : Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.md-layout {
  margin-bottom: 15px;
}
</style>
